var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image_modal_container"},[_c('img',{staticClass:"close_button",attrs:{"src":"/static/icons/close_white.svg"},on:{"click":_vm.handleClose}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imageUrl,"width":"100%"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f09e94c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ai/AiImageModal.vue
// module id = null
// module chunks = 